export default "__VITE_ASSET__BhOFt7ys__"